<template>
  <div>
    <div id="ReasignacionDeOperadores_div" class="w-100 px-5 py-4">
      <div id="TituloReasignacionDeOperadore_div">
        <h1>ASIGNACIÓN DE PERMISOS</h1>
        <h3>Control de asignación de permisos para ver audiencias en vivo</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudiencias"></FiltrosDeBusqueda>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Audiencias encontradas</h4>
            <h6></h6>
            <hr />
            <div id="PanelDeAudienciasPendientesPendientes_table" class="table-responsive">
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Fecha y Hora</th>
                    <th class="text-center">Tipo de Documento</th>
                    <th class="text-center">Consecutivo</th>
                    <th class="text-center">Partido Judicial</th>
                    <th class="text-center">Juzgado</th>
                    <th class="text-center">Materia</th>
                    <th class="text-center">Tipo de Audiencia</th>
                    <th class="text-center">Permisos</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="audiencias.length <= 0">
                    <td colspan="12" class="text-center">No existen registros de sesiones de audiencias</td>
                  </tr>
                  <tr v-else v-for="audiencia in audiencias" :key="audiencia.AudienciaId">
                    <td v-html="obtenFechaDeAudienciaConFormato(audiencia.FechaAudiencia)" style="width: 100px;"></td>
                    <td>{{audiencia.TipoDocumento.Nombre}}</td>
                    <td class="text-center">{{audiencia.Consecutivo}}</td>
                    <td>{{audiencia.PartidoJudicial.Nombre}}</td>
                    <td>{{audiencia.Area.Nombre}}</td>
                    <td>{{audiencia.Materia.Nombre}}</td>
                    <td>{{audiencia.TipoAudiencia.Nombre}}</td>
                    <td align="center">
                      <a v-on:click="agregarPermisos(audiencia.AudienciaId)" title="Agregar permisos">
                        <i class="fas fa-user-check"></i>
                      </a>                      
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import router from '@/router/index'
  import catalogos from '@/../static/js/catalogos'
  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.TiposEstatusDeLaAudiencia, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Todos },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo },
          { catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.OperadoresDeSala, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }
        ],
        audiencias: []
      }
    },
    mounted() {
      this.cargaAudiencias();
    },
    methods: {
      mouseover: function(){
      this.message = 'Good!'
    },
      agregarPermisos: function (audienciaId) { 
        router.push({ name: "AsignacionDePermisosParaVerEnVivo", params: { AudienciaId: audienciaId } });
      },
      obtenFechaDeAudienciaConFormato: function (fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      cargaAudiencias: function () {
        comun.SeEstaCargandoInformacion(true);

        const parametros = {
          FechaInicial: this.$store.state.Comun_FechaInicial,
          FechaFinal: this.$store.state.Comun_FechaFinal,
          TipoEstatusDeLaAudienciaId: this.$store.state.Forseti_Catalogos_001TipoEstatusDeAudienciaId,
          PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales.filtroDeBusqueda_PartidoJudicial,
          MateriaId: this.$store.state.PJ_Catalogos_002Materias.filtroDeBusqueda_Materia,
          AreaId: this.$store.state.PJ_Catalogos_001Areas.filtroDeBusqueda_Area,
          SalaId: this.$store.state.PJ_Catalogos_020Salas.filtroDeBusqueda_Sala,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.administracion.asignacionDePermisosParaVerEnVivo.GetAudienciasAgendadas,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            this.audiencias = [];
          } else {
            this.audiencias = respuesta.data.AudienciasAgendadas;
          }

          comun.SeEstaCargandoInformacion(false);
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
          this.audiencias = [];
        });
      },      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Forseti/Administracion/AsignacionDePermisosParaVerEnVivo/PanelDeAudiencias.vue